import { Injectable } from '@angular/core';
import {Subscription} from "rxjs";
import {MidiPlayerService} from "./midi-player.service";

@Injectable({
  providedIn: 'root'
})
export class AutoScrollService {

  private autoScrollSubscription: Subscription | null = null;
  enabled = false;
  active = false;
  // When true, autoscroll runs regardless of the user setting (used by continuous playback)
  private forced = false;

  constructor(private midiPlayerService: MidiPlayerService) { }

  startAutoScroll(): void {
    this.enabled = true;
    this.active = true;
    if (this.autoScrollSubscription) {
      this.autoScrollSubscription.unsubscribe();
      this.autoScrollSubscription = null;
    }
    this.autoScrollSubscription = this.midiPlayerService.progress$.subscribe((progress) => {
      if (this.active && (this.enabled || this.forced)) {
        if (!this.midiPlayerService.introPlaying && this.midiPlayerService.playing && progress >= 0 && progress <= 100) {
          this.scrollToPercentage(progress, 1200);
        } else if (this.midiPlayerService.introPlaying) {
          this.scrollToPercentage(0, 100);
        }
      }
    });
  }

  scrollToTop(): void {
    if(this.animateFrameRef) {
      cancelAnimationFrame(this.animateFrameRef);
    }
    this.scrollToPercentage(0, 100);
  }

  enableAutoScroll(): void {
    this.enabled = true;
  }

  disableAutoScroll(): void {
    this.enabled = false;
    // If autoscroll is currently forced (e.g., continuous playback), do not stop the active autoscroll
    if (!this.forced) {
      this.stopAutoScroll();
    }
  }

  // Force autoscroll on (used by continuous playback). Does not change the user setting.
  forceOn(): void {
    this.forced = true;
    // Ensure autoscroll is actively running
    this.startAutoScroll();
  }

  // Release forced autoscroll (used when continuous playback stops). Does not change the user setting.
  forceOff(): void {
    this.forced = false;
  }

  stopAutoScroll(scrollTop: boolean = false): void {
    this.active = false;
    if (this.autoScrollSubscription) {
      this.autoScrollSubscription.unsubscribe();
      this.autoScrollSubscription = null;
    }
    if(this.animateFrameRef) {
      cancelAnimationFrame(this.animateFrameRef);
    }
    if(scrollTop) {
      document.querySelector('.mat-sidenav-content')!.scrollTop = 0;
    }
  }

  animateFrameRef: any;
  scrollToPercentage(percentage: number, duration: number): void {

    const container = document.querySelector('.mat-sidenav-content')!;

    // Adjust the scroll position to effectively keep the current line in the middle of the screen
    const scrollAdjustment = 1 + 0.25*container.clientHeight/container.scrollHeight;
    //console.debug('scrollAdjustment', scrollAdjustment);

    const totalHeight = container.scrollHeight - container.clientHeight;
    const targetPosition = (percentage / 100) * totalHeight * scrollAdjustment;

    const startPosition = container.scrollTop;
    const distance = targetPosition - startPosition;

    let startTime: number | null = null;

    const animateScroll = (currentTime: number) => {
      if (!startTime) {
        startTime = currentTime;
      }

      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // Progress ranges from 0 to 1

      container.scrollTop = startPosition + distance * progress;

      if (timeElapsed < duration) {
        this.animateFrameRef = requestAnimationFrame(animateScroll);
      }
    };

    this.animateFrameRef = requestAnimationFrame(animateScroll);
  }
}
